// export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = 'http://localhost:5005/api';
export const BASE_URL = 'https://dash.prodashes.com/api';
